module.exports = __webpack_public_path__ + "img/azxy20_bg.08a73714.png";